import Stack from '@uikit/components/Stack/Stack';
import { AppScreen } from '../AppScreen/AppScreen';

import {
  AppleAppStoreButton,
  GooglePlayStoreButton,
} from '../AppStoreButtons/AppStoreButton';
import { BenefitCard } from '../BenefitCard/BenefitCard';
import { ContentContainer } from '../ContentContainer/ContentContainer';
import { Headline } from '../Headline/Headline';
import { List } from '../List/List';
import { Text } from '../Text/Text';
import styles from './Benefits.module.scss';

export const Benefits = () => {
  return (
    <div className={styles.base}>
      <ContentContainer>
        <Headline color="gradient" level={2}>
          Die Vorteile von enercity easyGo
        </Headline>

        <Text align="center" weight={300} width="m" className={styles.subTitle}>
          Mit der easyGo App erhalten Sie nicht nur einen komfortablen Zugang zu
          einem flächendeckenden Netz von Ladepunkten in ganz Deutschland.
          Zusätzlich bietet easyGo viele weitere praktische Funktionen.
        </Text>

        <div className={styles.cards}>
          <BenefitCard
            image={<AppScreen screen={'map'} />}
            content={
              <>
                <Headline level={3} align="left" color="gradient">
                  Überall laden
                </Headline>

                <Text weight={300} className={styles.cardContentText}>
                  Laden Sie mit der easyGo App besonders günstig an über 1.000
                  enercity-Ladepunkten in der Region Hannover und erhalten Sie
                  Zugang zu weiteren Ladepunkten Deutschlandweit.
                </Text>

                <List
                  rows={[
                    { content: 'Kartenansicht mit Filterfunktion' },
                    { content: 'Flächendeckendes Ladenetz' },
                    { content: 'Transparente Preise' },
                  ]}
                />
              </>
            }
          />
          <BenefitCard
            image={<AppScreen screen={'car'} />}
            content={
              <>
                <Headline level={3} align="left" color="gradient">
                  Ladevorgänge überwachen
                </Headline>

                <Text weight={300} className={styles.cardContentText}>
                  Die Zeit gehört Ihnen, während Ihr E-Auto lädt. Die App
                  benachrichtigt Sie, sobald der Ladevorgang abgeschlossen ist.
                  Bis dahin erhalten Sie Einblick in alle relevanten
                  Informationen.
                </Text>

                <List
                  rows={[
                    { content: 'Echtzeit-Daten & Ladeverlauf' },
                    { content: 'Push-Benachrichtigungen' },
                    { content: 'Übersichtliche Historie' },
                  ]}
                />
              </>
            }
          />
          <BenefitCard
            image={<AppScreen screen={'cost'} />}
            content={
              <>
                <Headline level={3} align="left" color="gradient">
                  Einfache Abrechnung
                </Headline>

                <Text weight={300} className={styles.cardContentText}>
                  Alle Bezahlvorgänge laufen gebündelt und übersichtlich auf
                  Ihrem easyGo-Konto zusammen und Sie erhalten eine monatliche
                  Rechnung. So behalten Sie Ihre Kosten immer im Blick.
                </Text>

                <List
                  rows={[
                    { content: 'Direkt mit der App bezahlen' },
                    { content: 'Monatliche Rechnungen' },
                    { content: 'Zahlungsmittel in der App verwalten' },
                  ]}
                />
              </>
            }
          />
          <BenefitCard
            image={<AppScreen screen="flexibleTariff" />}
            content={
              <>
                <Headline level={3} align="left" color="gradient">
                  Flexible Tarife
                </Headline>

                <Text weight={300} className={styles.cardContentText}>
                  In der easyGo App finden Sie den passenden Tarif - ob{' '}
                  gelegentlich unterwegs oder täglich auf Achse. Neu: enercity{' '}
                  easyGo SmartLaden - unser Tarif für Vielfahrerinnen.
                </Text>

                <List
                  rows={[
                    { content: 'Spürbare Ersparnis bei hoher Nutzung' },
                    { content: 'Keine langfristige Bindung' },
                    { content: 'Einfacher Wechsel direkt in der App' },
                  ]}
                />
              </>
            }
          />
        </div>

        <Stack
          gap="1rem"
          flexDirection={{ initial: 'column', md: 'row' }}
          className={styles.appBadgesBlock}
        >
          <Text className={styles.appTitle} gradient>
            <strong>Jetzt App laden</strong> und alle Vorteile nutzen
          </Text>

          <Stack
            gap="0.5rem"
            flexDirection={{ initial: 'column', xxs: 'row' }}
            justifyContent={{ initial: 'center', md: 'flex-end' }}
          >
            <GooglePlayStoreButton clickContext="Jetzt App laden und alle Vorteile nutzen" />
            <AppleAppStoreButton clickContext="Jetzt App laden und alle Vorteile nutzen" />
          </Stack>
        </Stack>
      </ContentContainer>
    </div>
  );
};
